import { render } from "./Logo.vue?vue&type=template&id=583c62d2"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/Logo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "583c62d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('583c62d2', __exports__)) {
    api.reload('583c62d2', __exports__)
  }
  
  module.hot.accept("./Logo.vue?vue&type=template&id=583c62d2", () => {
    api.rerender('583c62d2', render)
  })

}


export default __exports__